import * as types from './actionTypes';
import { store } from "../../index";

export function selectField(field) {
  return {type: types.SELECT_FIELD, field};
}

export function unselectField(field) {
  return {type: types.UNSELECT_FIELD, field};
}

export function addFilter() {
  return {type: types.ADD_FILTER};
}

export function removeFilter(filterId) {
  return {type: types.REMOVE_FILTER, filterId};
}

export function clearFilters() {
  return {type: types.CLEAR_FILTERS};
}

export function changeFilterField(filterId, fieldName) {
  const filterFields = store.getState().filterFieldsReducer;
  return {type: types.CHANGE_FILTER_FIELD, filterId, fieldName, filterFields};
}

export function changeFilterFieldNew(filterId, fieldName) {
  const filterFields = store.getState().filterFieldsReducer;
  return {type: types.CHANGE_FILTER_FIELD_NEW, filterId, fieldName, filterFields};
}

export function changeFilterOperator(filterId, operator) {
  return {type: types.CHANGE_FILTER_OPERATOR, filterId, operator};
}

export function changeFilterValue(filterId, value) {
  return {type: types.CHANGE_FILTER_VALUE, filterId, value};
}

export function setInitialState(state) {
  return { type: types.SET_INITAIL_STATE, payLoad: state }
}

export function unSetInitialState() {
  return { type: types.UNSET_INITIAL_STATE }
}

export function triggerGlobalClear() {
  return { type: types.TRIGGER_GLOBAL_CLEAR };
}